var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bg-gray-100 py-6",
      staticStyle: { height: "calc(100vh - 70px)" }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "bg-white overflow-hidden shadow rounded-lg max-w-4xl mx-auto"
        },
        [
          _c(
            "div",
            {
              staticClass: "bg-white px-4 py-5 border-b border-gray-200 sm:px-6"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-no-wrap"
                },
                [
                  _vm._m(0),
                  _c("div", { staticClass: "ml-4 mt-2 flex-shrink-0" }, [
                    _c(
                      "span",
                      { staticClass: "inline-flex rounded-md shadow-sm" },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-700 active:bg-indigo-700",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.createNew()
                              }
                            }
                          },
                          [_vm._v(" Create new ")]
                        )
                      ]
                    )
                  ])
                ]
              )
            ]
          ),
          _c("div", [
            _c(
              "ul",
              [
                _vm._l(_vm.campaigns, function(campaign, index) {
                  return _c("li", { key: index }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out cursor-pointer",
                        on: {
                          click: function($event) {
                            return _vm.gotoCampaignDetail(campaign)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "px-4 py-4 sm:px-6" }, [
                          _c("div", { staticClass: "grid grid-cols-7" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-sm leading-5 font-medium text-indigo-600 truncate col-span-2"
                              },
                              [_vm._v(" " + _vm._s(campaign.name) + " ")]
                            ),
                            _c("div", {
                              staticClass:
                                "col-span-3 text-gray-700 text-sm whitespace-pre-wrap"
                            })
                          ])
                        ])
                      ]
                    )
                  ])
                }),
                _vm.templates.length === 0
                  ? _c(
                      "li",
                      { staticClass: "text-center text-gray-700 text-sm p-20" },
                      [
                        _vm._v(
                          " Create a template to start sending marketing messages "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.templates.length > 0 && _vm.campaigns.length === 0
                  ? _c(
                      "li",
                      { staticClass: "text-center text-gray-700 text-sm p-20" },
                      [
                        _vm._v(
                          " Create a campaign to start sending marketing messages "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              2
            )
          ])
        ]
      ),
      _vm.showModal
        ? _c("CreateCampaign", {
            on: { close: _vm.closeModal, create: _vm.onCreate }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ml-4 mt-2" }, [
      _c("h3", { staticClass: "text-lg leading-6 font-medium text-gray-900" }, [
        _vm._v(" Campaigns ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }